import type { Task } from "@myapp/contract";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { taskApi } from "../service";
import { taskKeys } from "../task.keys";
import { scheduleKeys } from "../../../schedule/api/schedule.keys";

/** Files from the field — one round trip, see the appointment twin. */
export function useAddTaskTechnicianAttachments() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, files }: { id: number; files: File[] }) =>
      taskApi.uploadTechnicianAttachments(id, files).then((r) => r.data),
    onSuccess: (task) => {
      queryClient.setQueryData(taskKeys.detail(task.id), (prev: Task | undefined) =>
        prev ? { ...prev, technicianAttachments: task.technicianAttachments } : prev,
      );
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: taskKeys.all });
      queryClient.invalidateQueries({ queryKey: scheduleKeys.all });
    },
  });
}
